import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-12 min-w-min"
}

import { useProjectDurationSettings } from "@oculai/planner";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import ModalTW from "@/components/modals/ModalTW.vue";
import NonWorkingDays from "@/components/working_days/NonWorkingDays.vue";
import { useLoadCurrentProject } from "@/composables/project";
import { apiClient } from "@/repositories/clients";


export default /*#__PURE__*/_defineComponent({
  __name: 'NonWorkingDaysModal',
  props: {
  open: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emits = __emit;

const { projectDurationSettings, isProjectDurationSettingsLoading } =
  useProjectDurationSettings(apiClient);
const { project, isProjectLoading } = useLoadCurrentProject();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTW, {
    open: __props.open,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
    customCls: "h-fit max-w-[90vw] l:w-[120vh]"
  }, {
    content: _withCtx(() => [
      (_unref(isProjectDurationSettingsLoading) || _unref(isProjectLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (_unref(projectDurationSettings) && _unref(project))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(NonWorkingDays, {
                projectDurationSettings: _unref(projectDurationSettings),
                project: _unref(project)
              }, null, 8, ["projectDurationSettings", "project"])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})